module.exports = __webpack_public_path__ + "img/sample.9250838f.png";